import { render, staticRenderFns } from "./contentList.vue?vue&type=template&id=56b3df80&scoped=true&"
import script from "./contentList.vue?vue&type=script&lang=js&"
export * from "./contentList.vue?vue&type=script&lang=js&"
import style0 from "./contentList.vue?vue&type=style&index=0&id=56b3df80&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56b3df80",
  null
  
)

export default component.exports